<template>
  <div id="app-content" :class="[routename, auth]">
    <header-component></header-component>

    <transition name="routefade" mode="out-in" @beforeLeave="routeupdate" @afterLeave="routeafterleave">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <!-- <cookie-law>
      <div slot-scope="props">
        <div class="cookie-wrapper">
          <div class="text">
            <h3>{{'cookie-title'|t}}</h3>
            <p>{{'cookie-text'|t}} <router-link class="read-more" to="/cookies-policy" active-class="active">{{'cookie-link'|t}}</router-link></p>
          </div>
          <button class="btn" @click="props.accept"><span>{{'cookie-agree'|t}}</span></button>
        </div>
      </div>
    </cookie-law> -->
    <cookies>
    </cookies>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import Cookies from './Blocks/Cookies.vue'
    export default {
      components: { CookieLaw },
      data() {
        return {

        }
      },
      methods: {
        routeupdate(element) {
          if(this.$store.profileDropdown) this.$store.profileDropdown.hide()
          if(this.$store.cartDropdown) this.$store.cartDropdown.hide()
        },
        routeafterleave(element) {
          $("body").removeClass('menu-open')
          $("html").removeClass('html-menu-open')
          $("body").removeClass('dropdown-open')
          this.$root.$emit('triggerScroll')
        }
      },
      computed: {
        auth: function() {
          if(this.$route.meta.hasOwnProperty("auth") && this.$route.meta.auth) {
            if(this.$route.meta.auth.hasOwnProperty("roles") && this.$route.meta.auth.roles == 2) {
              return "admin"
            } else {
              return "user"
            }
          } else {
            return "public"
          }
        },
        routename: function() {
          return this.$route.name
        }
      },
      mounted() {
        this.$store.user = this.$auth.user()
        this.$store.loadCart()
        this.$store.loadSettings()
        new Style()
        $(window).scroll(function() {
          $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
          if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
            $('.banner-prefooter').addClass('in-viewport');
          }

          $('.noise').each(function() {
            if ( $(this).is( ':in-viewport' ) ) {
              $(this).addClass('in-viewport');
            } else {
              $(this).removeClass('in-viewport');
            }
          });
        });

        if(this.$i18n.locale == 'en') {
          $("body").addClass('locale-en');
          $("body").removeClass('locale-fr');
        } else {
          $("body").addClass('locale-fr');
          $("body").removeClass('locale-en');
        }
      }
    }
</script>

<i18n>
    {
      "en": {
        "cookie-title": "This website uses cookies",
        "cookie-text": "This website uses cookies to analyze traffic anonymously and to help us provide you with the best experience we can.",
        "cookie-link": "Read more",
        "cookie-agree": "I agree"
      },
      "fr": {
        "cookie-title": "Ce site web utilise des cookies",
        "cookie-text": "Ce site web utilise des cookies pour analyser le traffic de manière anonyme et pour nous aider à vous fournir la meilleure expérience possible.",
        "cookie-link": "Lire plus",
        "cookie-agree": "J'accepte"
      }
    }
  </i18n>
